import { IItem } from './IItem';
export class Axe extends IItem {
    constructor(context) {
        super(context);
    }
    /**
     *
     * @return {string}
     */
    getDisplayName() {
        return 'Axt';
    }
    /**
     *
     */
    onUseFromWorld() {
        if (this.context.getRandom().nextBoolean())
            this.context
                .getView()
                .ai()
                .comment$java_lang_String('Das ist eine sch\u00f6ne Axt.');
    }
    /**
     *
     * @return {string}
     */
    getGender() {
        return 'f';
    }
    /**
     *
     */
    onDrop() { }
    /**
     *
     */
    onTake() { }
    /**
     *
     * @return {boolean}
     */
    onUseFromInventory() {
        return this.context.getRandom().nextBoolean();
    }
    /**
     *
     */
    onEat() { }
    /**
     *
     * @return {boolean}
     */
    isEdible() {
        return false;
    }
    /**
     *
     * @return {boolean}
     */
    isActivator() {
        return true;
    }
    /**
     *
     * @return {number}
     */
    getValue() {
        return 44;
    }
}
Axe['__class'] = 'de.coco.mindLinq.world.items.Axe';
